(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-information"]) return;
  try {
    
  (function () {
    function wrapGiftPanel() {
      var container = document.getElementById('infiniteoptions-container');
      if (!container || container.querySelector('.wb-io-gift-stack')) return;

      var embroidery = container.querySelector('.emb_bt.no_order');
      if (!embroidery) return;

      var stack = document.createElement('div');
      stack.className = 'wb-io-gift-stack';
      stack.setAttribute('data-wb-io-gift-stack', '');

      var child = container.firstElementChild;
      while (child && child !== embroidery) {
        var next = child.nextElementSibling;
        stack.appendChild(child);
        child = next;
      }
      container.insertBefore(stack, embroidery);
    }

    function init() {
      wrapGiftPanel();
      var container = document.getElementById('infiniteoptions-container');
      if (!container) return;
      var mo = new MutationObserver(function () {
        if (!container.querySelector('.wb-io-gift-stack')) {
          wrapGiftPanel();
        }
      });
      mo.observe(container, { childList: true });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init, { once: true });
    } else {
      init();
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wb-brand-list"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function headerActivationOffset() {
      /* CSS の sticky top と同じく FSB オフセット + ヘッダー実高（:root の --wb-fsb-sticky-offset） */
      const rawFsb = getComputedStyle(document.documentElement)
        .getPropertyValue('--wb-fsb-sticky-offset')
        .trim();
      const rawHeader =
        getComputedStyle(document.body).getPropertyValue('--header-height').trim() ||
        getComputedStyle(document.documentElement).getPropertyValue('--header-height').trim();
      const fsb = parseFloat(rawFsb);
      const h = parseFloat(rawHeader);
      const fsbPx = Number.isFinite(fsb) && fsb > 0 ? fsb : 0;
      const headerPx = Number.isFinite(h) && h > 0 ? h : 60;
      return fsbPx + headerPx + 24;
    }

    function initBrandListAlphabetSpy(root) {
      const nav = root.querySelector('.wb-brand-list__alphabet');
      if (!nav) return;

      const links = [...nav.querySelectorAll('a.wb-brand-list__letter--active')];
      const anchors = [...root.querySelectorAll('.wb-brand-list__anchor[id^="brand-"]')];
      if (!links.length || !anchors.length) return;

      /* アンカージャンプ中はスクロール連動を止め、途中の頭文字が一瞬光るのを防ぐ */
      let anchorJumpLock = false;
      let anchorJumpTimer = null;

      function letterFromLink(link) {
        const href = link.getAttribute('href') || '';
        const fromHash = href.match(/#brand-([^#]+)$/);
        if (fromHash) return decodeURIComponent(fromHash[1]);
        return link.textContent.trim();
      }

      function setCurrentLetter(letter) {
        links.forEach((link) => {
          const key = letterFromLink(link);
          const isMatch = Boolean(letter) && key === letter;
          link.classList.toggle('is-current', isMatch);
          if (isMatch) {
            link.setAttribute('aria-current', 'true');
          } else {
            link.removeAttribute('aria-current');
          }
        });
      }

      function clearAnchorJumpLockAndSync() {
        anchorJumpLock = false;
        if (anchorJumpTimer) {
          clearTimeout(anchorJumpTimer);
          anchorJumpTimer = null;
        }
        compute();
      }

      function compute() {
        if (anchorJumpLock) return;
        const offset = headerActivationOffset();
        let chosen = null;
        for (const el of anchors) {
          const top = el.getBoundingClientRect().top;
          if (top <= offset) {
            chosen = el.id.replace(/^brand-/, '');
          }
        }
        setCurrentLetter(chosen);
      }

      links.forEach((link) => {
        link.addEventListener(
          'click',
          () => {
            const letter = letterFromLink(link);
            anchorJumpLock = true;
            setCurrentLetter(letter);
            if (anchorJumpTimer) clearTimeout(anchorJumpTimer);
            anchorJumpTimer = setTimeout(clearAnchorJumpLockAndSync, 700);
          },
          { passive: true }
        );
      });

      let ticking = false;
      window.addEventListener(
        'scroll',
        () => {
          if (!ticking) {
            ticking = true;
            requestAnimationFrame(() => {
              compute();
              ticking = false;
            });
          }
        },
        { passive: true }
      );

      window.addEventListener('resize', () => compute(), { passive: true });

      if ('scrollend' in window) {
        window.addEventListener(
          'scrollend',
          () => {
            if (anchorJumpLock) {
              clearAnchorJumpLockAndSync();
            } else {
              compute();
            }
          },
          { passive: true }
        );
      }

      compute();
    }

    function initAll() {
      document.querySelectorAll('.wb-brand-list').forEach(initBrandListAlphabetSpy);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initAll, { once: true });
    } else {
      initAll();
    }
  })();

  } catch(e) { console.error(e); }
})();
})();
